/** @format */

import React from "react";
import { useSelector } from "react-redux";

import So from "./cards/So";
import Manbalar from "./cards/Manbalar";
import Balanslar from "./cards/Balanslar";
import Chart11 from "../../components/Chart11";
import Chart10 from "../../components/Chart10";
import SugorishCart from "./cards/SugorishCart";
import ErrorBoundary from "../../../../components/ErrorBoundry";

function Fargona({ date }) {
  const districts = useSelector((state) => state.data.districts);

  return (
    <div className='dashboard'>
      <div className='mgk-box and'>
        <Balanslar date={date} a={0} s={1} z={0} />
        <So date={date} />
        <SugorishCart />
      </div>

      <div className='data-content card3 mt-3'>
        {[Chart11, Chart10].map((Chart, idx) => (
          <div
            className='card statistic-card bosh-sahifa-barchart px-2'
            key={idx}>
            <ErrorBoundary>
              <Chart districts={districts} />
            </ErrorBoundary>
          </div>
        ))}
      </div>

      <Manbalar date={date} singlerow={0} region='and' />
    </div>
  );
}

export default Fargona;
